import { useQuery } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosResponse } from 'axios';

import { ListImpactSchema } from '@/features/irm/entities/events';
import { apiV1 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export type ImpactEventsResponse = ListImpactSchema;

export const getImpactEvents = (): Promise<AxiosResponse<ImpactEventsResponse>> => {
  return apiV1.get(`/v1/irm/event/impact`);
};

type QueryFnType = typeof getImpactEvents;

type UseEventOptions = {
  companyId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useImpactEvents = ({ companyId, config }: UseEventOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    onError: () => {
      notification.error({ message: `Não foi possível buscar os impactos eventos relevantes.` });
    },
    ...config,
    queryKey: [`impact-events`, companyId],
    queryFn: () => getImpactEvents(),
  });
};

